import React, {Component} from 'react';
import {connect} from 'react-redux';
import {getLanguage} from '../../store/rootReducer';
import auth from "../../services/auth/AuthProvider";

class Login extends Component {

  componentDidMount() {
    auth.login(this.props.language);
  };

  render() {
    return (
        <div/>
    )
  };
}

const mapStateToProps = (state) => {
  return {
    language: getLanguage(state)
  }
};

export default connect(
    mapStateToProps
)(Login);